import { render } from "./index.vue?vue&type=template&id=90ec3346&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=90ec3346&lang=less&scoped=true"

import exportComponent from "D:\\rwkj\\suershouyyph-mobile\\保安端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90ec3346"]])

export default __exports__